import type React from 'react'
import { DocumentLayoutProvider } from '@/contexts/document-layout-context'
import { EditorCommandStateProvider } from '@/contexts/editor-command-state-context'
import { EditorCommandsProvider } from '@/contexts/editor-commands-context'
import { EditorSettingsProvider } from '@/contexts/editor-settings-context'
import { EditorToolsProvider } from '@/contexts/editor-tools-context'
import { TextDefaultsProvider } from '@/contexts/text-defaults-context'
import type { EditorContextValues } from '../hooks/use-editor-context-values'

interface EditorProvidersProps {
  values: EditorContextValues
  children: React.ReactNode
}

/**
 * The editor's six shared contexts. Home builds the values (`useEditorContextValues`); this only
 * nests the providers, slowest-changing outermost.
 */
export function EditorProviders({ values, children }: EditorProvidersProps) {
  return (
    <EditorCommandsProvider value={values.commands}>
      <DocumentLayoutProvider value={values.layout}>
        <EditorSettingsProvider value={values.settings}>
          <TextDefaultsProvider value={values.textDefaults}>
            <EditorToolsProvider value={values.tools}>
              <EditorCommandStateProvider value={values.commandState}>
                {children}
              </EditorCommandStateProvider>
            </EditorToolsProvider>
          </TextDefaultsProvider>
        </EditorSettingsProvider>
      </DocumentLayoutProvider>
    </EditorCommandsProvider>
  )
}
